export default {"src":"/_next/static/media/alert.8ac3378c.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};